<template>
    <!-- eslint-disable max-len -->
    <div
        v-show="context.Service.enabled"
        :data-lang="$i18n.locale"
        class="patsnap-biz-header-widget-case-time"
    >
        <PtTooltip
            effect="dark"
            placement="bottom"
            :visible-arrow="false"
        >
            <template slot="content">
                <span
                    v-if="isWorking || context.Service.isPaused"
                    class="patsnap-biz-header-widget-case-time_tooltip_content"
                >
                    <template v-if="isWorking">
                        <i class="case-time_working-icon" /> <span>{{ $t('case_time.rec') }}</span>
                    </template>
                    <template v-else>
                        <i class="case-time_pause-icon" /> <span>{{ $t('case_time.paused') }}</span>
                    </template>

                    <i class="patsnap-biz-header-widget-case-time_tooltip_split_line" />
                    {{ hoverLabel }}
                </span>
                <span v-else>{{ $t('PtHeaderWidgetCaseTime.tooltip') }}</span>
            </template>
            <PtHeaderWidget
                icon="Timer"
                data-balloon-pos="down"
                @click="handleClickTimer"
            />
        </PtTooltip>
        <CaseTime ref="case" />
        <div
            v-if="context.Service.isWorking"
            class="patsnap-biz-header-widget-case-time__working-icon case-time_working-icon"
        />
        <div
            v-if="context.Service.isPaused"
            class="patsnap-biz-header-widget-case-time__pause-icon case-time_pause-icon"
        />
    </div>
</template>

<script>
import PtHeaderWidget from '@patsnap-biz/header-widget';
import Tooltip from 'element-ui/lib/tooltip';
import { CaseTime, createContext, CASE_TIME_CONTEXT } from './CaseTime/index';
import { Service } from './Service';
import cn from '../locales/cn';
import en from '../locales/en';
import jp from '../locales/jp';
import tw from '../locales/tw';

export default {
    name: 'PtHeaderWidgetCaseTime',
    i18n: {
        fallbackLocale: 'cn',
        messages: {
            cn, en, jp, tw,
        },
    },
    components: {
        PtTooltip: Tooltip,
        CaseTime,
        PtHeaderWidget,
    },
    inject: {
        headerService: 'service',
    },
    provide() {
        return {
            [CASE_TIME_CONTEXT]: this.context,
        };
    },
    props: {
        /**
         * 该 props 接受一个包含 psAxios 属性对象
         */
        service: {
            type: Object,
            default() {
                return new Service();
            },
        },
    },
    data() {
        const vm = this;
        const {
            axios, passportUrl, accountServiceUrl, accountUrl,
        } = this.service;
        const context = createContext({
            hiddenButton: true,
            i18n: vm.$i18n,
            debug: window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1'),
            urls: {
                passportUrlBase: passportUrl,
                accountServiceUrlBase: accountServiceUrl,
                accountUrlBase: accountUrl,
            },
            transfer: axios,
        });
        return {
            context,
            hoverLabel: '',
            enabled: false,
        };
    },
    computed: {
        isWorking() {
            return this.context.Service.isWorking;
        },
        CurrentStatus() {
            return this.context.Service.CurrentStatus;
        },
    },
    watch: {
        CurrentStatus: {
            handler() {
                // eslint-disable-next-line no-lonely-if
                if (this.refreshTextUnsub) {
                    this.refreshTextUnsub();
                }
                if (this.isWorking) {
                    this.refreshTextUnsub = this.context.Service.timer.getDurationFormattedSubscription(() => {
                        this.updateHoverLabel();
                    });
                } else {
                    this.updateHoverLabel();
                }
            },
            immediate: true,
        },
    },
    beforeDestroy() {
        if (this.refreshTextUnsub) {
            this.refreshTextUnsub();
        }
    },
    methods: {
        updateHoverLabel() {
            const { hours, days } = this.context.Service.timer.getDurationFormatted();
            this.hoverLabel = `${days ? this.$t('case_time.days', { num: days }) : ''} ${hours}`;
        },
        handleClickTimer() {
            this.context.showDialog();
        },
    },
};
</script>
